__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/2d37e3b/_next/";